import { render, staticRenderFns } from "./MiddiumTotalCard.vue?vue&type=template&id=14616048&scoped=true&"
import script from "./MiddiumTotalCard.vue?vue&type=script&lang=js&"
export * from "./MiddiumTotalCard.vue?vue&type=script&lang=js&"
import style0 from "./MiddiumTotalCard.vue?vue&type=style&index=0&id=14616048&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14616048",
  null
  
)

export default component.exports